import { render, staticRenderFns } from "./AubeCoinForthingStatus.vue?vue&type=template&id=4ffaac00&"
import script from "./AubeCoinForthingStatus.vue?vue&type=script&lang=js&"
export * from "./AubeCoinForthingStatus.vue?vue&type=script&lang=js&"
import style0 from "./AubeCoinForthingStatus.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports